import { render, staticRenderFns } from "./ylGoods.vue?vue&type=template&id=5866fdbe&scoped=true&"
import script from "./ylGoods.vue?vue&type=script&lang=js&"
export * from "./ylGoods.vue?vue&type=script&lang=js&"
import style0 from "./ylGoods.vue?vue&type=style&index=0&id=5866fdbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5866fdbe",
  null
  
)

export default component.exports